import script from "./BusinessesSelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./BusinessesSelector.vue?vue&type=script&lang=ts&setup=true"

import "./BusinessesSelector.vue?vue&type=style&index=0&id=95433fec&lang=sass"

const __exports__ = script;

export default __exports__